(function () {
  'use strict';

  var SELECTOR = '[data-mosaic-scroll-zoom]';
  var instances = [];
  var frameRequested = false;

  function clamp(value, min, max) {
    return Math.min(
      Math.max(value, min),
      max
    );
  }

  function smoothStep(value) {
    return value * value * (3 - 2 * value);
  }

  function getZoom(root) {
    var mobile = window
      .matchMedia('(max-width: 749px)')
      .matches;

    var value = mobile
      ? root.dataset.mobileZoom
      : root.dataset.desktopZoom;

    return Math.max(
      1,
      Number(value) || (mobile ? 3 : 5)
    );
  }

  function update(instance) {
    var root = instance.root;

    if (!root.isConnected) {
      return;
    }

    var rect = root.getBoundingClientRect();

    var available = Math.max(
      1,
      root.offsetHeight - window.innerHeight
    );

    var rawProgress = clamp(
      -rect.top / available,
      0,
      1
    );

    var easedProgress = smoothStep(rawProgress);

    var scale =
      1 +
      (getZoom(root) - 1) *
        easedProgress;

    var contentOpacity = clamp(
      1 - rawProgress * 3.2,
      0,
      1
    );

    var instructionOpacity = clamp(
      1 - rawProgress * 8,
      0,
      1
    );

    root.style.setProperty(
      '--msz-progress',
      rawProgress.toFixed(4)
    );

    root.style.setProperty(
      '--msz-scale',
      scale.toFixed(4)
    );

    root.style.setProperty(
      '--msz-content-opacity',
      contentOpacity.toFixed(4)
    );

    root.style.setProperty(
      '--msz-instruction-opacity',
      instructionOpacity.toFixed(4)
    );
  }

  function updateAll() {
    frameRequested = false;

    /*
      Shopify может полностью заменить секцию
      после изменения её настроек.

      Поэтому перед каждым обновлением снова
      ищем актуальную секцию на странице.
    */
    initialiseAll(document);

    instances = instances.filter(
      function (instance) {
        return instance.root.isConnected;
      }
    );

    instances.forEach(update);
  }

  function requestUpdate() {
    if (frameRequested) {
      return;
    }

    frameRequested = true;

    window.requestAnimationFrame(updateAll);
  }

  function initialise(root) {
    if (!root) {
      return;
    }

    if (
      root.dataset.mosaicScrollReady ===
      'true'
    ) {
      return;
    }

    root.dataset.mosaicScrollReady = 'true';

    instances.push({
      root: root
    });

    var image = root.querySelector(
      '.mosaic-scroll-zoom__image'
    );

    if (image) {
      image.addEventListener(
        'load',
        requestUpdate,
        {
          once: true
        }
      );
    }

    requestUpdate();
  }

  function initialiseAll(scope) {
    var container = scope || document;

    if (
      container.matches &&
      container.matches(SELECTOR)
    ) {
      initialise(container);
    }

    if (container.querySelectorAll) {
      Array.prototype.forEach.call(
        container.querySelectorAll(SELECTOR),
        initialise
      );
    }
  }

  function start() {
    initialiseAll(document);

    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      requestUpdate,
      {
        passive: true
      }
    );

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        initialiseAll(event.target);
        requestUpdate();
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      requestUpdate
    );

    document.addEventListener(
      'shopify:section:select',
      function (event) {
        initialiseAll(event.target);
        requestUpdate();
      }
    );

    document.addEventListener(
      'shopify:block:select',
      requestUpdate
    );

    if (
      window.MutationObserver &&
      document.body
    ) {
      var observer = new MutationObserver(
        function () {
          requestUpdate();
        }
      );

      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }
  }

  if (window.__mosaicScrollZoomLoaded) {
    initialiseAll(document);
    requestUpdate();
    return;
  }

  window.__mosaicScrollZoomLoaded = true;

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();